var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mt-12"},[_c('v-card-actions',[_vm._v(" 404 Page not found! ")]),_c('v-card-actions',[_c('v-btn',{attrs:{"primary":"","to":"/"}},[_vm._v("Go back Dashboard home page")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }